(function () {
	const scrollTop = () => {
		const btnScrollTop = document.querySelector(".scroll-top");
    let scrollTimer = null;

		window.addEventListener("scroll", function () {
			if (!btnScrollTop) return;

			// 超过一屏才允许显示
			if (scrollY > document.documentElement.clientHeight) {
				// 滚动时立即隐藏
				btnScrollTop.classList.remove("show");

				// 清除上一次的定时器
				clearTimeout(scrollTimer);

				// 重新设置定时器，滚动停止 200ms 后再显示
				scrollTimer = setTimeout(() => {
					btnScrollTop.classList.add("show");
				}, 200);
			} else {
				// 回到一屏以内时，始终隐藏
				btnScrollTop.classList.remove("show");
			}
		});

		btnScrollTop.onclick = () => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		};
	};

	scrollTop();

	document.addEventListener("shopify:section:load", function () {
		scrollTop();
	});
})();
